import { render, staticRenderFns } from "./NewTransaction.vue?vue&type=template&id=aee60e3a&scoped=true&"
import script from "./NewTransaction.vue?vue&type=script&lang=js&"
export * from "./NewTransaction.vue?vue&type=script&lang=js&"
import style0 from "./NewTransaction.vue?vue&type=style&index=0&id=aee60e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee60e3a",
  null
  
)

export default component.exports